// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lBnxA","colBig":"styles_colBig__3VF20","colSmall":"styles_colSmall__16l7K"};